export const storesToGeoJSON = (stores, selectedStore = null) => {
  const transformedStores = stores.map(transformStoreData)
  const validStores = transformedStores.filter(
    store => store.latitud && store.longitud
  )
  return {
    type: "FeatureCollection",
    features: validStores.map((store, index) => ({
      type: "Feature",
      properties: {
        id: store.pwid,
        numero: `${index + 1}`,
        nombre: store.nombre,
        title: store.title,
        direccion: store.direccion,
        localidad: store.localidad,
        provincia: store.provincia,
        pais: store.pais,
        isSelected: selectedStore?.pwid === store.pwid,
      },
      geometry: {
        type: "Point",
        coordinates: [store.longitud, store.latitud],
      },
    })),
  }
}

export const transformStoreData = store => {
  let latitud = null
  let longitud = null

  if (store.coordenadasGps) {
    const coords = store.coordenadasGps.split("|")
    if (coords.length === 2) {
      latitud = parseFloat(coords[0])
      longitud = parseFloat(coords[1])
    }
  }

  return {
    ...store,
    pwid: store.pwid, // Usar localidad_pwid como ID único
    title: store.title,
    direccion: store.direccion,
    latitud,
    longitud,
    // Mantener los campos originales por compatibilidad
    localidad: store.localidad,
    provincia: store.provincia,
    pais: store.pais,
  }
}
